import { Link as GravityLink } from "@gravity-ui/uikit";
import { ComponentPropsWithoutRef } from "react";
import { Link as RouterLink } from "react-router-dom";

import { isExternalLink, safeSlug } from "./utils";

export const MarkdownComponents = (basePath: string) => ({
  h1: (props: ComponentPropsWithoutRef<"h1">) => {
    const id = safeSlug(props.children);
    return <h1 id={id} {...props} />;
  },

  h2: (props: ComponentPropsWithoutRef<"h2">) => {
    const id = safeSlug(props.children);
    return <h2 id={id} {...props} />;
  },

  h3: (props: ComponentPropsWithoutRef<"h3">) => {
    const id = safeSlug(props.children);
    return <h3 id={id} {...props} />;
  },

  a: ({ href = "", children }: ComponentPropsWithoutRef<"a">) => {
    if (isExternalLink(href)) {
      return (
        <GravityLink
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          view="primary"
        >
          {children}
        </GravityLink>
      );
    }

    return (
      <RouterLink to={href.startsWith("/") ? href : `${basePath}/${href}`}>
        <GravityLink href="" view="primary">
          {children}
        </GravityLink>
      </RouterLink>
    );
  },
});
